import React, { useEffect, useState, useRef } from 'react';

import { LangText } from "../zustand/dict.js";

import images from '../libs/images';
import consts from '../libs/consts';

import { clickDownS3, getFileName, regFileDoc, regFileImage } from '../utils/utils';

import Button from './Button';
import Image from './Image';

import { toast } from 'react-toastify';

export default function InputRangeDual(props) {
    const {
        startText = "0",
        endText = "100",
        value1 = 0,
        value2 = 0,
        setValue1,
        setValue2,
        step = 1,
        min = 0,
        max = 100
    } = props;

    const containRef = useRef(null);
    const pointRef1 = useRef(null);
    const pointRef2 = useRef(null);

    const [width, setwidth] = useState(0);

    const [inputValue, setInputValue] = useState(0);

    const calcWidth = (val) => {
        let userValue = Number(val) - min;
        let range = (max - min);
        let result = ((userValue / range) * 100).toFixed(2);
        return result;
    }

    const inputChange = (e) => {
        let inputVal = Number(e.target.value)
        // console.log(inputVal)
        let diff1 = Math.abs(value1 - inputVal)
        let diff2 = Math.abs(value2 - inputVal)

        if (diff1 >= diff2) {
            pointRef2.current.style.setProperty("left", `calc(${calcWidth(inputVal)}% - 10px)`)
            setValue2(inputVal)
        } else {
            pointRef1.current.style.setProperty("left", `calc(${calcWidth(inputVal)}% - 10px)`)
            setValue1(inputVal)
        }
    }

    useEffect(() => {
        pointRef1.current.style.setProperty("left", `calc(${calcWidth(value1)}% - 10px)`)
        pointRef2.current.style.setProperty("left", `calc(${calcWidth(value2)}% - 10px)`)
    }, [value1, value2])

    return (
        <div className='input_range_section'>
            <p style={{ flexShrink: 0, width: 68 }} className='body2 color-g300 padding_lr16'>{startText}</p>
            <div className='input_slide_box'>
                <div
                    ref={containRef}
                    style={{
                        position: "absolute",
                        display: "flex",
                        background: "#D1D1D1",
                        width: "calc(100%)",
                        borderRadius: 100,
                        height: 6,
                    }}
                >
                    <div style={{
                        position: "absolute",
                        background: "#A67CFF",
                        left: calcWidth(value1) + "%",
                        width: `${calcWidth(value2) - calcWidth(value1)}%`,
                        borderRadius: 100,
                        height: 6,
                        // transition: "width .2s"
                    }} />
                    <div
                        ref={pointRef1}
                        style={{
                            position: "absolute",
                            background: "#A67CFF",
                            width: 20,
                            height: 20,
                            top: "calc(50% - 10px)",
                            borderRadius: 10,
                            border: "1px solid white",
                            // left: `calc(${value1}% - 10px)`,
                            // transition: "left .2s"
                        }}
                    />
                    <div
                        ref={pointRef2}
                        style={{
                            position: "absolute",
                            background: "#A67CFF",
                            width: 20,
                            height: 20,
                            top: "calc(50% - 10px)",
                            borderRadius: 10,
                            border: "1px solid white",
                            // left: `calc(${value2}% - 10px)`,
                            // transition: "left .2s"
                        }}
                    />

                    <div
                        style={{
                            position: "absolute",
                            width: "100%",
                            top: "calc(50% - 10px)",
                            height: "20px",
                            cursor: "pointer"
                        }}
                    />
                </div>

                <input
                    type="range"
                    min={min}
                    max={max}
                    step={step}
                    onChange={inputChange} />
            </div>
            <p style={{ flexShrink: 0, width: 68 }} className='body2 color-g300 padding_lr16'>{endText}</p>
        </div>
    )
}